import React, { useEffect, useState } from "react";
import { useVerifyOtp } from "../../hooks/Otp"; // Adjust the path
import Swal from "sweetalert2";
import image from "../../images/logo.png";

function Otp() {
  const savedEmail = localStorage.getItem("MyOtpemail");
  const { loading, error, message, verifyOtp } = useVerifyOtp();


  const [imageSize, setImageSize] = useState({ width: 1, height: 1 });

  useEffect(() => {
    const img = new Image();
    img.src = image;
    img.onload = () => {
      setImageSize({ width: img.width, height: img.height });
    };
  }, []);

  // Calculate dynamic width
  const aspectRatio = imageSize.width / imageSize.height;
  const cardWidth = aspectRatio > 1.5 ? "max-w-5xl" : "max-w-3xl";


  // Handle success and error messages with SweetAlert
  useEffect(() => {
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: error,
        confirmButtonColor: "#dc2626",
        timer: 3000,
        timerProgressBar: true,
      });
    }

    if (message) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: message,
        confirmButtonColor: "#16a34a",
        timer: 3000,
        timerProgressBar: true,
      });
    }
  }, [error, message]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const otp = e.target.otp.value;
    if (!savedEmail) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No email found. Please sign up again.",
        confirmButtonColor: "#dc2626",
      });
      return;
    }
    verifyOtp(savedEmail, otp);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-6xl w-full bg-white rounded-xl shadow-xl overflow-hidden lg:flex">
        <div className="w-full my-auto p-6 lg:p-8 lg:w-1/2">
          <form className="max-w-md mx-auto" onSubmit={handleSubmit}>
            <h2 className="text-center text-2xl mb-6 text-gray-800">
              OTP Verification
            </h2>
            <div className="space-y-6">
              <div>
                <label htmlFor="otp" className="block mb-2 text-gray-600">
                  OTP has been sent to{" "}
                  <span className="font-bold">
                    {savedEmail || "your email"}
                  </span>
                  . Please enter the code here:
                </label>
                <input
                  name="otp"
                  type="text" // Changed from email to text since OTP is numeric
                  required
                  className="bg-slate-100 w-full text-sm text-slate-800 px-4 py-3 rounded-md outline-none border focus:border-green-600 focus:bg-transparent"
                  placeholder="Enter OTP"
                />
              </div>
            </div>

            <div className="!mt-12">
              <button
                type="submit"
                disabled={loading}
                className={`w-full shadow-xl py-2.5 px-4 text-sm font-semibold rounded text-white bg-green-600 hover:bg-green-700 focus:outline-none ${
                  loading ? "opacity-75 cursor-not-allowed" : ""
                }`}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>
            </div>
          </form>
        </div>

        <div className="relative hidden lg:flex lg:w-1/2">
          <img
            alt="Sign in poster"
            src={image}
            className="w-full h-auto object-cover"
            style={{ aspectRatio: `${imageSize.width} / ${imageSize.height}` }}
          />
        </div>
      </div>
    </div>
  );
}

export default Otp;
